// 日志操作
export function traceLog (key, value) {
  let performanceLog = JSON.parse(localStorage.getItem('performanceLog'))
  if (!performanceLog) {
    performanceLog = {[key]: value}
  } else {
    performanceLog[key] = value
  }
  localStorage.setItem('performanceLog', JSON.stringify(performanceLog))
}
